export default {
  ticketList: {},
  blockList: [],
  generalConfig: {},
  checkoutConfig: {},
  keyStorage: {},
  workingHour: {},
  bookingWorkingHour: {},
  smsContent: {},
  policyData: [],
  taxSetting: [],
  tipSetting: [],
  serviceFee: {},
  storeRating: {},
  countryCode: null,
}
